module.exports = __webpack_public_path__ + "img/video-img.a642817f.png";